import { NgModule, ModuleWithProviders } from "@angular/core";

import { LoadingService } from "./loading.service";
import { ModalService } from "./modal.service";
import { AuthService } from "./auth.service";
import { AlertService } from "./alert.service";
import { RepositoryModule } from "../repositories/repository.module";
import { GridService } from "./grid.service";
import { UserService } from "./user.service";
import { DefaultAuthProcessorFactory } from "./guards/processors/auth-processor-factory";
import { OverlayService } from "./overlay.service";
import { DialogService } from "./dialog.service";
import { ToastService } from "./toast.service";
import { NewsService } from "./news.service";
import { FeatureViewService } from "./feature-view.service";
import { BeneficiaryService } from "./pbm/beneficiary.service";
import { CompanyService } from "./pbm/company.service";
import { HeaderService } from "./header.service";
import { BenefitService } from "./pbm/benefit.service";
import { NetworkFinancialService } from "./network-financial.service";
import { MedicalPrescriptionService } from "./medical-prescription.service";
import { TherapeuticClassService } from "./pbm/therapeutic-class.service";
import { ProductService } from "./pbm/product.service";
import { FinancialStatementService } from "./pbm/financial-statement.service";
import { FileExportService } from "./file-export.service";
import { JobDescriptionService } from "./pbm/job-description.service";
import { IndustryDiscountsService } from "./pbm/industry-discounts.service";

@NgModule({
  imports: [RepositoryModule.forRoot()],
})
export class ServiceModule {
  static forRoot(): ModuleWithProviders<ServiceModule> {
    return {
      ngModule: ServiceModule,
      providers: [
        AlertService,
        AuthService,
        GridService,
        LoadingService,
        ModalService,
        UserService,
        DefaultAuthProcessorFactory,
        OverlayService,
        DialogService,
        ToastService,
        NewsService,
        FeatureViewService,
        BeneficiaryService,
        CompanyService,
        HeaderService,
        BenefitService,
        ProductService,
        TherapeuticClassService,
        NetworkFinancialService,
        MedicalPrescriptionService,
        FinancialStatementService,
        FileExportService,
        JobDescriptionService,
        IndustryDiscountsService,
      ],
    };
  }
}
